import React, { useState, useEffect } from 'react'

export const CurrentUserContext = React.createContext({})

export const useCurrentUser = () => React.useContext(CurrentUserContext)


export const CurrentUserContextProvider = ({ children }) => { 
  const [currentUser, setCurrentUser] = useState({ roles: [] })

  const onTrack = (type, key, tags = {}, value = null) => {
    let body = new FormData()
    body.append('type', type)
    body.append('key', 'voicearchive.system.feature.ui.' + key)
    body.append('value', value)

    Object.entries(tags).forEach(([key, value]) => {
      if (value) {
        body.append(`tags[${key}]`, value)
      }
    })

    fetch('/system/stats.json', {
      method: 'POST',
      body,
    })
  }

  const track = {
    gauge: (key, time, tags = {}) => onTrack('gauge', key, tags, time),
    increment: (key, tags = {}) => onTrack('increment', key, tags),
    timing: (key, time, tags = {}) => onTrack('timing', key, tags, time),
  }

  const hasRole = (role) => currentUser.roles.includes(role);

  const impersonate = (id) => {
    fetch('/system/impersonate.json?userId=' + id)
    .then((response) => response.json())
    .then(({isloggedin, userdata}) => {
      if (isloggedin) {
        system.destroyReactApp()
        reactHistory.push('/dashboard')
        window.location.reload(true)
      } else {
        toastr.error('Something went wrong. Please try again.')
      }
    });
  }

  useEffect(() => {
    fetch(`/rest/v2/user/me`, { credentials: 'same-origin' })
      .then((response) => response.json())
      .then(({ data }) => {
        if (data) {
          setCurrentUser({
            ...data,
            image: data ? data.image || 'https://voicearchive-branding.s3.eu-central-1.amazonaws.com/avatar-fallback.jpg' : null,
            date_time_format: data.timeformat == 12 ? 'D. MMM YYYY h:mm A' : 'D. MMM YYYY HH:mm',
          })
        }
      })
      .catch((err) => window.alert(err))
  }, [])

  return (
    <CurrentUserContext.Provider value={{ track, hasRole, impersonate, ...currentUser }}>
      { children }
    </CurrentUserContext.Provider>
  )
}

export default useCurrentUser
